import {
  EMERGENCY_MULTI_DOMAIN_PATTERN,
  EMERGENCY_SORENSON_DOMAIN_PATTERN,
} from 'features/caller-session/constants/';

export const isUnregisteredCaller = (remoteIdentifier: string): boolean => {
  // General check for unregistered.sorenson.com
  const unregisteredSorensonRegex =
    /sip:(?:[^@]+@)?unregistered\.sorenson\.com(:\d+)?(;.*)?/i;

  return unregisteredSorensonRegex.test(remoteIdentifier);
};

/**
 * Determines if the remote identifier represents an unregistered emergency call.
 * An emergency call is typically a 911 call from a user who is not logged in
 * or registered with the system.
 *
 * @param remoteIdentifier - The SIP URI of the caller, which may include angle brackets
 * @returns true if the call is an unregistered emergency call, false otherwise
 */
export const isUnregisteredEmergencyCall = (
  remoteIdentifier: string
): boolean => {
  // Step 1: Define regex patterns to identify emergency calls

  // Pattern 1: Specifically matches emergency calls from unregistered.sorenson.com domain
  // Format: sip:911xxx@unregistered.sorenson.com where xxx represents additional digits, typically used for identification purposes

  // Step 2: Test the sanitized identifier against both patterns
  const isEmergencySorensonCall =
    EMERGENCY_SORENSON_DOMAIN_PATTERN.test(remoteIdentifier);
  const isEmergencyFromOtherDomains =
    EMERGENCY_MULTI_DOMAIN_PATTERN.test(remoteIdentifier);

  // Step 3: Return true if the identifier matches either pattern
  return isEmergencySorensonCall || isEmergencyFromOtherDomains;
};
